var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',_vm._g({attrs:{"height":"24","width":"24","xmlns":"http://www.w3.org/2000/svg"}},_vm.$listeners),[_c('path',{attrs:{"d":"M20 10a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2v-8a2 2 0 0 1 2-2zm-8-9a6 6 0 0 1 6 6v2.999L16 10V7a4 4 0 1 0-8 0v3H6V7a6 6 0 0 1 6-6z","fill-rule":"evenodd"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }